<template>
  <div class="modal fade" id="Payments" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-full" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <div class="container-fluid">
            <div class="row">
              <div class="col-9 col-sm-5 col-lg-5 my-auto">
                <h5 class="modal-title" id="PaymentsLabel">Payments</h5>
              </div>
              <div class="col-3 col-sm-7 my-auto">
                <div>
                  <div>
                    <span>
                      <a class="close">
                        <i
                          class="far fa-times-circle fa-2x"
                          data-dismiss="modal"
                          
                          aria-label="Close"
                        ></i>
                      </a>
                    </span>
                  </div>
                  <div>
                    <!-- <router-link :to="{ path: '/dashboard'}" target="_blank">
                                  <span class="fa-stack fa-2x fsm float-right">
                                      <i class="far fa-circle fa-stack-2x"></i>
                                      <i class="fas fa-external-link-alt fa-stack-1x"></i>
                                  </span>
                    </router-link>-->
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-body">
          <div class="container-fluid">
            <div class="row">
              <div class="col-lg-12">
                <div class="table-responsive-lg pre-scrollable fh">
                  <b-table striped :items="p" :fields="paymentsFields" :busy="p===null">
                    <template v-slot:table-busy>
                      <b-row align-h="center">
                        <propagate-loader class="mb-3" :color="primaryColour" :size="16"></propagate-loader>
                      </b-row>
                    </template>
                    <template slot="CustomerReference" slot-scope="data">
                      <router-link
                        :to="{path: '/dashboard/' + data.item.AccountReference}"
                        target="_blank"
                        class="underline"
                      >{{data.item.AccountReference}}</router-link>
                    </template>
                    <template slot="Type" slot-scope="data">{{wordSplit(data.item.Type)}}</template>
                    <template
                      slot="TransactionDate"
                      slot-scope="data"
                    >{{data.item.TransactionDate | moment("DD.MM.YY")}}</template>
                    <template slot="Description" slot-scope="data">{{data.item.Description}}</template>
                    <template slot="TransactionType" slot-scope="data">{{data.item.TransactionType}}</template>
                    <template slot="Amount" slot-scope="data">{{data.item.Amount | currency}}</template>

                    <template
                      slot="FailureTypeId"
                      slot-scope="data"
                    >{{wordSplit(data.item.FailureTypeId)}}</template>
                  </b-table>
                </div>
                <!-- <div v-else>There are no payments in this run</div> -->
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Vue from "vue";
import _filters from "@/mixins/filters.js";

export default {
  mixins: [_filters],
  data() {
    return {
      activeService: {
        serial: 0
      },
      paymentsFields: {
        CustomerReference: {
          lable: "Account Reference",
          class: "text-center"
        },
        Type: {
          label: "Type",
          class: "text-center"
        },
        TransactionDate: {
          label: "Transaction Date",
          class: "text-center"
        },
        Description: {
          label: "Payment Method",
          class: "text-center"
        },
        TransactionType: {
          label: "Transaction Type",
          class: "text-center"
        },
        Amount: {
          label: "Amount",
          class: "text-center"
        },
        FailureTypeId: {
          label: "Status",
          class: "text-center"
        }
      }
    };
  },
  methods: {
    wordSplit(word) {
      var foo = "";
      var splitWord = word.split(/(?=[A-Z0-9])/);
      for (let i = 0; i < splitWord.length; i++) {
        foo += splitWord[i] + " ";
      }
      return foo;
    }
  },
  computed: {
    primaryColour() {
      return Vue.config.honeycomb.theme;
    },
    details() {
      return this.$store.state.finances.runDetails;
    },
    p() {
      return this.$store.state.finances.payments;
    }
  }
};
</script>

